import {Money} from '../services/Money.js'

export default class Allocation {
    constructor(
        allocation_id,
        amount,
        currency,
        exchange_rate,
        exchanged_amount,
        exchange_target_currency,
        local_balance = 0,
        operation_id = 0,
        id = 0,
        department_id = 0,
        contractor_id = 0,
        document_number,
        name_of_service,
        checked = false,
        disabled = false,
        readonly = false,
        to_delete = false,
        operation = null,
        allocation = null,
    ) {
        this.allocation_id = allocation_id;
        this.amount = amount;
        this.currency = currency;
        this.exchange_rate = exchange_rate;
        this.exchanged_amount = exchanged_amount;
        this.exchange_target_currency = exchange_target_currency;
        this.local_balance = local_balance;
        this.id = id;
        this.operation_id = operation_id;
        this.department_id = department_id;
        this.contractor_id = contractor_id;
        this.document_number = document_number;
        this.name_of_service = name_of_service;
        this.checked = checked;
        this.disabled = disabled;
        this.readonly = readonly;
        this.to_delete = to_delete;
        this.operation = operation;
        this.allocation = allocation;

        // this.money = new Money()
    }

    static fromObject(anonymousObject) {
        const {allocation_id, amount, currency, exchange_rate, exchanged_amount, exchange_target_currency, local_balance,
            operation_id, id, department_id, contractor_id, document_number, name_of_service, checked, disabled, readonly, to_delete, operation, allocation} = anonymousObject;

        return new Allocation(
            allocation_id,
            amount,
            currency,
            exchange_rate ? exchange_rate : 1,
            exchanged_amount,
            exchange_target_currency,
            local_balance ? local_balance : 0,
            operation_id ? operation_id : 0,
            id ? id : 0,
            department_id ? department_id : 0,
            contractor_id ? contractor_id : 0,
            document_number ? document_number : null,
            name_of_service ? name_of_service : null,
            checked ? checked : false,
            disabled ? disabled : false,
            readonly ? readonly : false,
            to_delete ? to_delete : false,
            operation ? operation : null,
            allocation ? allocation : null,
        )
    }
};
